







































































import { Component, Vue, Watch, Prop } from 'vue-property-decorator'
import { Action, Mutation } from 'vuex-class'
import { mapState } from 'vuex'
import _PaymentIQ1Click from 'paymentiq-1click-client'
import LoginContent from '@/components/gambling/LoginContent.vue'
import LoginEmailBtn from '@/components/gambling/LoginEmailBtn.vue'
import Cashier from '@/components/Cashier'
import { setThemeConfigs } from '@/utils/gamblingHelpers'

@Component({
  components: {
    LoginContent,
    Cashier,
    LoginEmailBtn
  },
  computed: {
    ...mapState({
      isAuthenticated: ({ gamblingContext }: any): boolean => gamblingContext.isAuthenticated,
      choosedTheme: ({ gamblingContext }: any): string[] => gamblingContext.choosedTheme,
      logInModal: ({ gamblingContext }: any): boolean => gamblingContext.logInModal,
      extraConfigs: ({ cashierContext }: any): number => cashierContext.extraConfigs,
      drawerMiniVariantState: ({ gamblingContext }: any): boolean => gamblingContext.drawerMiniVariant
    })
  }
})

export default class NavDrawerContent extends Vue {
  @Action('loginUserPassword') loginUserPassword: any
  @Action('setTheme') setTheme: any
  @Mutation('setDrawerMiniVariant') setDrawerMiniVariant: any

  drawerMiniVariantState!: boolean
  cashierDrawer: boolean = true
  choosedTheme!: string
  isAuthenticated!: boolean
  logInModal!: boolean
  showProgess: boolean = false
  extraConfigs: any
  $cashierConfigs!: any

  @Watch('isAuthenticated')
  onIsAuthenticated (val: boolean) {
    if (val) {
      this.drawerMiniVariant = true
    }
  }

  @Watch('choosedTheme')
  onChoosedTheme (val: string) {
    this.setCashierConfigs()
  }

  get drawerMiniVariant () {
    return this.drawerMiniVariantState
  }
  set drawerMiniVariant (val: boolean) {
    this.setDrawerMiniVariant(val)
  }

  get getLogInModal (): any {
    return this.logInModal
  }

  cashierCallback (type: string) {
    switch (type) {
      case 'isHidden':
        this.showProgess = true
        break
      case 'isVisible':
        this.showProgess = false
        break
      case 'cashier-preview-style':
        return 'height:100vh!important;background:#ffffff'
      default:
        break
    }
  }

  setCashierConfigs () {
    this.$cashierConfigs('dynamicCashierType')
    this.setTheme({
      cashierbackground: {
        color: '#ffffff'
      },
      labels: {
        color: '#333333'
      },
      headings: {
        color: '#333333'
      }
    })
  }

  created () {
    this.setCashierConfigs()
  }
}
